import * as eHubApi from "./data.service";

//#region Warehouse
export const createWarehouse = (req) => eHubApi.post("/api/warehouse/create", req);

export const editWarehouse = (req) => eHubApi.put(`/api/warehouse/edit?warehouseCode=${req.warehouseCode}`, req);

export const getWarehouse = (req) => eHubApi.get(`/api/warehouse/get?warehouseCode=${req.warehouseCode}`);

export const getWarehouseList = (req) => eHubApi.get(`/api/warehouse/list?customerCode=${req.customerCode}`);

export const getWarehouseOptions = () => eHubApi.get("/api/warehouse/options");
//#endregion Warehouse

export const getUserOptions = (req) => eHubApi.get(`/api/user/options?customerCode=${req.customerCode}`);

//Zone
//#region Zone
export const getZoneList = (req) => eHubApi.get(`/api/zone/list?customerCode=${req.customerCode}&active=${req.active}`);

export const getZoneStatusCount = (req) => eHubApi.get(`/api/zone/get-status-count?customerCode=${req.customerCode}`);

export const getZone = (req) =>
  eHubApi.get(`/api/zone/get?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}`);

export const getZoneOptions = (req) =>
  eHubApi.get(`/api/zone/options?warehouseCode=${req.whCode}&zoneType=${req.zoneType}`);

export const createZone = (req) => eHubApi.post("/api/zone/create", req);

export const editZone = (req) =>
  eHubApi.put(`/api/zone/edit?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}`, req.req);

export const deactivateZone = (req) =>
  eHubApi.del(`/api/zone/delete?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}`);

export const activeZone = (req) =>
  eHubApi.put(`/api/zone/activate?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}`);

export const uploadZone = (req) => eHubApi.post("/api/zone/upload", req);
//#endregion Zone

//Location
//#region Location
export function getLocationList(req) {
  return eHubApi.get(`/api/location/list?customerCode=${req.customerCode}&active=${req.active}`);
}

export function getLocationStatusCount(req) {
  return eHubApi.get(`/api/location/get-status-count?customerCode=${req.customerCode}`);
}

export function createLocation(req) {
  return eHubApi.post("/api/location/create", req);
}

export function getLocationOptions(req) {
  return eHubApi.get(`/api/location/options?whCode=${req.whCode}&zoneID=${req.zoneID}`);
}

export function getLocation(req) {
  return eHubApi.get(
    `/api/location/get?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`
  );
}

export function editLocation(req) {
  return eHubApi.put(
    `/api/location/edit?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`,
    req
  );
}

export function uploadLocation(req) {
  return eHubApi.post("/api/location/upload", req);
}

export function updateLocation(req){
  return eHubApi.post("/api/location/bulk-update", req);
}

export function deactivateLocation(req) {
  return eHubApi.del(
    `/api/location/delete?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`
  );
}
export function activeLocation(req) {
  return eHubApi.put(
    `/api/location/activate?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&locationID=${req.locationID}`
  );
}
//#endregion Location

//Vendor
//#region Vendor
export const createVendor = (req) => eHubApi.post("/api/vendor/create", req);

export const editVendor = (req) =>
  eHubApi.put(
    `/api/vendor/edit?vendorCode=${req.vendorCode}&customerCode=${req.customerCode}`,
    req
  );

export const getVendorByCode = (req) =>
  eHubApi.get(`/api/vendor/get?vendorCode=${req.vendorCode}&customerCode=${req.customerCode}`);

export const getVendorList = (req) =>
  eHubApi.get(`/api/vendor/list?customerCode=${req.customerCode}&active=${req.active}`);

export const deleteVendor = (req) =>
  eHubApi.del(`/api/vendor/delete?vendorCode=${req.vendorCode}&customerCode=${req.customerCode}`);

export const activeVendor = (req) =>
  eHubApi.put(`/api/vendor/activate?vendorCode=${req.vendorCode}&customerCode=${req.customerCode}`);

export const getVendorOptions = (req) =>
  eHubApi.get(`/api/vendor/options?customerCode=${req.custCode}`);

export const getVendorOptionsWithName = (req) =>
  eHubApi.get(`/api/vendor/options2?customerCode=${req.customerCode}`);

export const getVendorStatusCount = (req) =>
  eHubApi.get(`/api/vendor/get-status-count?customerCode=${req.customerCode}`);
//#endregion Vendor

//SKU
//#region SKU
export function getSKUList(req) {
  const {
    customerCode,
    pagination: { pageIndex, pageSize },
    columnFilters,
    sorting,
  } = req;
  const filter = columnFilters.map((x) => {
    if(x.id === "skuCode") {
      const value = encodeURIComponent(x.value)
      return `${x.id}=${value}`
    } 
    return `${x.id}=${x.value}` 
  });
  let filterString = filter.join("&");
  let sortString = "";
  if (filter.length > 0) filterString = "&" + filterString;

  if (sorting.length > 0) {
    sortString = `&sortBy=${sorting[0].id}&sortOrder=${sorting[0].desc ? "desc" : "asc"}`;
  }
  return eHubApi.get(
    `/api/sku/list?customerCode=${customerCode}&active=${req.active}&pageIndex=${pageIndex}&pageSize=${pageSize}${filterString}${sortString}`
  );
}

export function getSKUStatusCount(req) {
  return eHubApi.get(`/api/sku/get-status-count?customerCode=${req.customerCode}`);
}

export function getSKUByCode(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(`/api/sku/get?customerCode=${req.customerCode}&skuCode=${skuCode}`);
}

export function getSKULog(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(`/api/sku/log?customerCode=${req.customerCode}&skuCode=${skuCode}`);
}

export function createSKU(req) {
  return eHubApi.post("/api/sku/create", req);
}

export function uploadSKUImage(req) {
  return eHubApi.post("/api/sku/image/create", req);
}

export function editSKU(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.put(`/api/sku/edit?customerCode=${req.customerCode}&skuCode=${skuCode}`, req);
}

export function editSKUImage(req) {
  return eHubApi.post("/api/sku/image/edit", req);
}

export function uploadSKU(req) {
  return eHubApi.post("/api/sku/upload", req);
}

export function getSKUListv2(req) {
  const {
    customerCode,
    pagination: { pageIndex, pageSize },
    columnFilters,
    sorting,
  } = req;
  const filter = columnFilters.map((x) => `${x.id}=${x.value}`);
  let filterString = filter.join("&");
  let sortString = "";
  if (filter.length > 0) filterString = "&" + filterString;

  if (sorting.length > 0) {
    sortString = `&sortBy=${sorting[0].id}&sortOrder=${sorting[0].desc ? "desc" : "asc"}`;
  }
  console.log(filterString);
  console.log(sortString);
  return eHubApi.get(
    `/api/sku/v2/list3?customerCode=${customerCode}&active=${req.active}&pageIndex=${pageIndex}&pageSize=${pageSize}${filterString}${sortString}`
  );
}

export function getSKUCategoryOptions(req) {
  return eHubApi.get(`/api/sku/category-options?customerCode=${req.customerCode}`);
}

export function getSKUOptions_latest(req) {
  return eHubApi.get(`/api/sku/options?customerCode=${req.customerCode}`);
}

export function searchSKU(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(`/api/sku/search?customerCode=${req.custCode}&skuCode=${skuCode}`);
}

export function deactivateSKU(req) {
  return eHubApi.post("/api/sku/delete", req);
}

export const batchDeactivateSKU = (req) => eHubApi.post("/api/sku/batch-delete", req);

export function activeSKU(req) {
  return eHubApi.post("/api/sku/activate", req);
}

export function exportSKU(req) {
  const { customerCode, columnFilters } = req;
  const filter = columnFilters.map((x) => `${x.id}=${x.value}`);
  let filterString = filter.join("&");
  if (filter.length > 0) filterString = "&" + filterString;

  return eHubApi.post_file(
    `/api/sku/export?customerCode=${customerCode}&active=${req.active}${filterString}`,
    {}
  );
}

// Mini upload: export SKUPackType rows missing Case/Weight info, and upload a corrected sheet
// that only overwrites UPMCase/UPMGrossWeight/UPMNetWeight.
export function exportSKUPackTypeWeight(req) {
  const { customerCode } = req;
  return eHubApi.post_file(`/api/sku-pack-type/export?customerCode=${customerCode ?? ""}`, {});
}

export function uploadSKUPackTypeWeight(req) {
  return eHubApi.post("/api/sku-pack-type/upload", req);
}
//#endregion SKU

//#region Company
export const createCompany = (req) => eHubApi.post("/api/company/create", req);

export const getCompanyByCode = (code) => eHubApi.get(`/api/company/get?companyCode=${code}`);

export const editCompany = (req) =>
  eHubApi.put(`/api/company/edit?companyCode=${req.companyCode}`, req);

export const getCompanyList = (req) => eHubApi.get(`/api/company/list?active=${req.active}`);

export const deactiveCompany = (req) =>
  eHubApi.del(`/api/company/delete?companyCode=${req.companyCode}`);

export const activeCompany = (req) =>
  eHubApi.put(`/api/company/activate?companyCode=${req.companyCode}`);

export const getCompanyStatusCount = () => eHubApi.get("/api/company/get-status-count");
//#endregion Company

//#region Customer
export const getCustomerList = (req) => eHubApi.get(`/api/customer/list?active=${req.active}`);

export const createCustomer = (req) => eHubApi.post("/api/customer/create", req);

export const getCustomerOptions = () => eHubApi.get("/api/customer/options");

export const getCustomer = (code) => eHubApi.get(`/api/customer/get?customerCode=${code}`);

export const getCustomerLastPreallocate = (req) =>
  eHubApi.get(`/api/customer/get-last-preallocate?customerCode=${req.customerCode}`);

export const editCustomer = (req) =>
  eHubApi.put(`/api/customer/edit?customerCode=${req.customerCode}`, req);

export const deactivateCustomer = (req) =>
  eHubApi.del(`/api/customer/delete?customerCode=${req.customerCode}`);
export const activeCustomer = (req) =>
  eHubApi.put(`/api/customer/activate?customerCode=${req.customerCode}&currentCustomerCode=${req.currentCustCode}`);

export const uploadCustomerLogo=(req)=>
  eHubApi.post("/api/customer/logo/upload",req)

export const removeCustomerLogo=(req)=>
  eHubApi.post("/api/customer/logo/remove",req)

export const getCustomerLogo=(req)=>
  eHubApi.get(`/api/customer/logo?customerCode=${req.customerCode}&type=${req.type}`)

export const getCustomerStatusCount = () => eHubApi.get("/api/customer/get-status-count");
//#endregion Customer

//UOM
//#region UOM
export const createUOM = (req) => eHubApi.post("/api/uom/create", req);

export const getUOMList = () => eHubApi.get("/api/uom/list");

export const getUOM = (req) => eHubApi.get(`/api/uom/get?uomID=${req.uomid}`);

export const editUOM = (req) => eHubApi.put(`/api/uom/edit?uomID=${req.uomid}`, req);

export const getUOMOptions = (req) => {
  const typeString = ``;
  if (Boolean(req.type)) typeString =`?type=${req.type}`
  return eHubApi.get(`/api/uom/options${typeString}`);
}
//#endregion UOM

//Carrier
//#region Carrier
export const createCarrier = (req) => eHubApi.post("/api/carrier/create", req);

export const getCarrierList = (req) => eHubApi.get(`/api/carrier/list?active=${req.active}`);

export const getCarrier = (req) => eHubApi.get(`/api/carrier/get?carrierCode=${req.carrierCode}`);

export const editCarrier = (req) =>
  eHubApi.put(`/api/carrier/edit?carrierCode=${req.carrierCode}`, req);

export const deactivateCarrier = (req) =>
  eHubApi.del(`/api/carrier/delete?carrierCode=${req.carrierCode}`);

export const activeCarrier = (req) =>
  eHubApi.put(`/api/carrier/activate?carrierCode=${req.carrierCode}`);

export const getCarrierStatusCount = () => eHubApi.get("/api/carrier/get-status-count");
//#endregion Carrier

//Consignee
//#region Consignee
export const getConsigneeList = (req) =>
  eHubApi.get(`/api/consignee/list?customerCode=${req.customerCode}&active=${req.active}`);

export const getConsigneeStatusCount = (req) =>
  eHubApi.get(`/api/consignee/get-status-count?customerCode=${req.customerCode}`);

export const getConsignee = (req) =>
  eHubApi.get(
    `/api/consignee/get?customerCode=${req.customerCode}&consigneeCode=${req.consigneeCode}`
  );

export const getConsigneeOptions = (req) =>
  eHubApi.get(`/api/consignee/options?customerCode=${req.customerCode}`);

export const getConsigneeOptions2 = (req) =>
  eHubApi.get(`/api/consignee/options2?customerCode=${req.customerCode}`);

export const createConsignee = (req) => eHubApi.post("/api/consignee/create", req);

export const editConsignee = (req) =>
  eHubApi.put(
    `/api/consignee/edit?customerCode=${req.customerCode}&consigneeCode=${req.consigneeCode}`,
    req
  );

export const deactivateConsignee = (req) =>
  eHubApi.del(
    `/api/consignee/delete?customerCode=${req.customerCode}&consigneeCode=${req.consigneeCode}`
  );

export const activeConsignee = (req) =>
  eHubApi.put(
    `/api/consignee/activate?customerCode=${req.customerCode}&consigneeCode=${req.consigneeCode}`
  );
export const uploadConsignee = (req) => eHubApi.post("/api/consignee/upload", req);
//#endregion Consignee

//Vendor SKU
//#region
export const getVendorSKUList2 = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/vendor-sku/list?customerCode=${req.customerCode}&skuCode=${skuCode}&active=${req.active}`
  );
};

export const getVendorSKUStatusCount = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/vendor-sku/get-status-count?customerCode=${req.customerCode}&skuCode=${skuCode}`
  );
};

export const getVendorSKUByCode = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/vendor-sku/get?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
};

export const createVendorSKU = (req) => {
  return eHubApi.post("/api/vendor-sku/create", req);
};

export const editVendorSKU = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.put(
    `/api/vendor-sku/edit?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`,
    req
  );
};

export const deactivateVendorSKUById = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.del(
    `/api/vendor-sku/delete?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
};

export const activeVendorSKU = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.put(
    `/api/vendor-sku/activate?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
};
//#endregion

//SKU Pack Type
//#region
export function getSKUPackTypeList2(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku-pack-type/list?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}&active=${req.active}`
  );
}

export function getSKUPackTypeStatusCount(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku-pack-type/get-status-count?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
}

export function getSKUPackTypeByCode(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku-pack-type/get?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
}

export function createSKUPackType(req) {
  return eHubApi.post("/api/sku-pack-type/create", req);
}

export function editSKUPackType(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.put(
    `/api/sku-pack-type/edit?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`,
    req
  );
}

export function deactivateSKUPackTypeById(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.del(
    `/api/sku-pack-type/delete?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
}

export function getSKUPackUOM2(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku-pack-type/get-uom?customerCode=${req.custCode}&skuCode=${skuCode}&vendorCode=${req.vendCode}`
  );
}

export function getPackTypeUOM(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku-pack-type/get-uom?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}`
  );
}

export const activeSKUPackType = (req) => {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.put(
    `/api/sku-pack-type/activate?customerCode=${req.customerCode}&skuCode=${skuCode}&vendorCode=${req.vendorCode}&packType=${req.packType}`
  );
};
//#endregion

//Shipping Zone
//#region
export function getShipingZoneList(req) {
  return eHubApi.get(`/api/shipping-zone/list?active=${req.active}`);
}

export function getShippingZoneStatusCount() {
  return eHubApi.get("/api/shipping-zone/get-status-count");
}

export function getShippingZone(req) {
  return eHubApi.get(`/api/shipping-zone/get?shippingZone=${req.shippingZone}`);
}

export function getShippingZoneOptions() {
  return eHubApi.get(`/api/shipping-zone/options`);
}

export function createShippingZone(req) {
  return eHubApi.post("/api/shipping-zone/create", req);
}

export function editShippingZone(req) {
  return eHubApi.put(`/api/shipping-zone/edit?shippingZone=${req.shippingZone}`, req);
}

export function deactivateShippingZone(req) {
  return eHubApi.del(`/api/shipping-zone/delete?shippingZone=${req.shippingZone}`);
}

export function activeShippingZone(req) {
  return eHubApi.put(`/api/shipping-zone/activate?shippingZone=${req.shippingZone}`);
}
//#endregion

//Customer Warehouse Setting
//#region
export function createCustWhSetting(req) {
  return eHubApi.post("/api/cust-wh-setting/create", req);
}

export function getCustWhSetting(req) {
  return eHubApi.get(`/api/cust-wh-setting/get?customerCode=${req.customerCode}`);
}

export function editCustWhSetting(req) {
  return eHubApi.put(`/api/cust-wh-setting/edit?customerCode=${req.customerCode}`, req);
}

export function getCurrencyCode() {
  return eHubApi.get("/api/cust-wh-setting/get-currency-code");
}

export function getCustWhOptions(req) {
  return eHubApi.get(`/api/cust-wh-setting/options?customerCode=${req.customerCode}`);
}
//#endregion

//Retail Barcode
//#region
export function getSKURetailBarcode(req) {
  const skuCode = encodeURIComponent(req.skuCode)
  return eHubApi.get(
    `/api/sku/retail-barcode/get?skuCode=${skuCode}&customerCode=${req.customerCode}&vendorCode=${req.vendorCode}`
  );
}

export function createSKURetailBarcode(req) {
  return eHubApi.post("/api/sku/retail-barcode/create", req);
}
//#endregion

//Customer Carrier
//#region
export function createCustomerCarrier(req) {
  return eHubApi.put(`/api/customer/carrier/edit?customerCode=${req.customerCode}`, req.req);
}

export function getCustomerCarrier(req) {
  return eHubApi.get(`/api/customer/carrier/list?customerCode=${req.customerCode}`);
}
//#endregion

//SKU Kit
//#region
export function createSKUKit(req) {
  return eHubApi.post(`/api/sku/kit/create`, req);
}

export function getSKUKit(req) {
  return eHubApi.get(`/api/sku/kit/get?customerCode=${req.customerCode}&skuCode=${req.skuCode}`);
}

export function editSKUKit(req) {
  return eHubApi.put(
    `/api/sku/kit/edit?customerCode=${req.customerCode}&skuCode=${req.skuCode}`,
    req.req
  );
}

export function uploadSKUKit(req) {
  return eHubApi.post("/api/sku/kit/upload", req);
}

export function getSKUKitLog(req) {
  return eHubApi.get(`/api/sku/kit/log?customerCode=${req.customerCode}&skuCode=${req.skuCode}`);
}
//#endregion
function createPreferredLocation(req) {
  return eHubApi.post("/api/preferredLocation/create", req);
}

function getPreferredLocation(req) {
  const query = [];
  if (req.warehouseCode) query.push(`warehouseCode=${req.warehouseCode}`);
  if (req.zoneID) query.push(`zoneID=${req.zoneID}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  if (req.customerCode) query.push(`customerCode=${req.customerCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/get?` + queryString);
}

function deactivatePreferredLocation(req) {
  return eHubApi.del(
    `/api/preferredLocation/delete?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`
  );
}

function activatePreferredLocation(req) {
  return eHubApi.del(
    `/api/preferredLocation/activate?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`
  );
}

function editPreferredLocationBySKU(req) {
  return eHubApi.put(
    `/api/preferredLocation/edit?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`,
    req.req
  );
}

function deleteLocationForPrefLoc(req) {
  return eHubApi.put(
    `/api/preferredLocation/deleteLocation?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`,
    req.req
  );
}

function uploadPreferredLocation(req) {
  return eHubApi.post("/api/preferredLocation/upload", req);
}

function getPreferredLocationStatusCount(req) {
  return eHubApi.get(`/api/preferredLocation/get-status-count?customerCode=${req.customerCode}`);
}

function getPreferredLocationList(req) {
  const query = [];
  if (req.warehouseCode) query.push(`warehouseCode=${req.warehouseCode}`);
  if (req.zoneID) query.push(`zoneID=${req.zoneID}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  if (req.customerCode) query.push(`customerCode=${req.customerCode}`);
  if (req.vendorCode) query.push(`vendorCode=${req.vendorCode}`);
  if (req.skuCode) query.push(`sku=${req.skuCode}`);
  if (req.status !== null) query.push(`status=${req.status}`);
  const queryString = query.join("&");
  return eHubApi.get("/api/preferredLocation/list?" + queryString);
}

function getRackList(req) {
  return eHubApi.get(`/api/preferredLocation/rackList?whCode=${req.whCode}&zoneId=${req.id}`);
}

function getLocationsByRack(req) {
  return eHubApi.get(
    `/api/preferredLocation/listByRack?whCode=${req.whCode}&zoneId=${req.id}&rack=${req.rack}`
  );
}

function getSKUListByVendCode(req) {
  const query = [`custCode=${req.custCode}`];
  if (req.vendCode) query.push(`vendCode=${req.vendCode}`);
  if (req.category) query.push(`category=${req.category}`);
  if (req.group) query.push(`group=${req.group}`);
  if (req.subgroup) query.push(`subgroup=${req.subgroup}`);
  if (Boolean(req.skuCodes)){
    const skuCodes = req.skuCodes.split(',', 10).map(x => encodeURIComponent(x.trim())).join("&skuCodes=");
    query.push(`skuCodes=` + skuCodes)
  }
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/skuListByCode?` + queryString);
}

function getCategoryOptions(req) {
  const query = [`custCode=${req.custCode}`];
  if (req.vendCode) query.push(`vendCode=${req.vendCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/categoryOption?` + queryString);
}

function getGroupOptions(req) {
  const query = [`custCode=${req.custCode}`];
  if (req.vendCode) query.push(`vendCode=${req.vendCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/groupOption?` + queryString);
}

function getSubGroupOptions(req) {
  const query = [`custCode=${req.custCode}`];
  if (req.vendCode) query.push(`vendCode=${req.vendCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/subgroupOption?` + queryString);
}

//PickFace Location
function createPickFaceLocation(req) {
  return eHubApi.post("/api/pickFaceLocation/create", req);
}

function getPickFaceLocation(req) {
  const query = [];
  if (req.warehouseCode) query.push(`warehouseCode=${req.warehouseCode}`);
  if (req.zoneID) query.push(`zoneID=${req.zoneID}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  if (req.customerCode) query.push(`customerCode=${req.customerCode}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/pickFaceLocation/get?` + queryString);
}

function deactivatePickFaceLocation(req) {
  return eHubApi.del(
    `/api/pickFaceLocation/delete?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`
  );
}

function activatePickFaceLocation(req) {
  return eHubApi.del(
    `/api/pickFaceLocation/activate?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`
  );
}

function editPickFaceLocation(req) {
  return eHubApi.put(
    `/api/pickFaceLocation/edit?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`,
    req.req
  );
}

function deleteLocationForPickFace(req) {
  return eHubApi.put(
    `/api/pickFaceLocation/deleteLocation?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`,
    req.req
  );
}

function deletePickFaceDetail(req) {
  return eHubApi.put(
    `/api/pickFaceLocation/deleteDetail?warehouseCode=${req.warehouseCode}&zoneID=${req.zoneID}&rack=${req.rack}`,
    req.req
  );
}

function uploadPickFaceLocation(req) {
  return eHubApi.post("/api/pickFaceLocation/upload", req);
}

function getPickFaceLocationStatusCount(req) {
  return eHubApi.get(`/api/pickFaceLocation/get-status-count?customerCode=${req.customerCode}`);
}

function getLocationsSetAsPickFace(req) {
  const query = [];
  if (req.whCode) query.push(`warehouseCode=${req.whCode}`);
  if (req.id) query.push(`zoneID=${req.id}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/preferredLocation/locationSetAsPickFace?` + queryString);
}

function getLocationsSetAsPreferred(req) {
  const query = [];
  if (req.whCode) query.push(`warehouseCode=${req.whCode}`);
  if (req.id) query.push(`zoneID=${req.id}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/pickFaceLocation/locationSetAsPreferred?` + queryString);
}

function getPickFaceLocationList(req) {
  const query = [];
  if (req.warehouseCode) query.push(`warehouseCode=${req.warehouseCode}`);
  if (req.zoneID) query.push(`zoneID=${req.zoneID}`);
  if (req.rack) query.push(`rack=${req.rack}`);
  if (req.customerCode) query.push(`customerCode=${req.customerCode}`);
  if (req.vendorCode) query.push(`vendorCode=${req.vendorCode}`);
  if (req.skuCode) query.push(`sku=${req.skuCode}`);
  if (req.status !== null) query.push(`status=${req.status}`);
  const queryString = query.join("&");
  return eHubApi.get("/api/pickFaceLocation/list?" + queryString);
}

function getCustomersByWarehouse(req) {
  return eHubApi.get(`/api/cust-wh-setting/customers?warehouseCode=${req.warehouseCode}`);
}

function getVendorWithCustCode(req) {
  return eHubApi.get(`/api/pickFaceLocation/vendorWithCustomerOptions?warehouseCode=${req.warehouseCode}`);
}

function getModuleTypes() {
  return eHubApi.get("/api/teamRole/moduleTypes");
}

function getModuleList(moduleType) {
  return eHubApi.get(`/api/teamRole/modules?moduleType=${moduleType}`);
}

function createTeamRole(req) {
  return eHubApi.post("/api/teamRole/create", req);
}

function editTeamRole(req) {
  return eHubApi.put(`/api/teamRole/edit?teamName=${req.teamName}`, req.req);
}

function getTeamRole(teamName) {
  return eHubApi.get(`/api/teamRole/get?teamName=${teamName}`);
}

function getTeamRoleList(status) {
  return eHubApi.get(`/api/teamRole/list?status=${status}`);
}

function getTeamRoleStatusCount() {
  return eHubApi.get("/api/teamRole/get-status-count");
}

function deactivateTeamRole(teamName) {
  return eHubApi.del(`/api/teamRole/delete?teamName=${teamName}`);
}

function activateTeamRole(teamName) {
  return eHubApi.put(`/api/teamRole/active?teamName=${teamName}`);
}

function createAdjustmentReason(req) {
  return eHubApi.post("/api/adjustmentReasonCode/create", req);
}

function getAdjustmentReasonList(req) {
  return eHubApi.get(`/api/adjustmentReasonCode/list?active=${req.active}`);
}

function getAdjustmentReason(req) {
  return eHubApi.get(`/api/adjustmentReasonCode/get?reasonCode=${req.reasonCode}`);
}

function editAdjustmentReason(req) {
  return eHubApi.put(`/api/adjustmentReasonCode/edit?reasonCode=${req.reasonCode}`, req);
}

function deactivateAdjustmentReason(req) {
  return eHubApi.del(`/api/adjustmentReasonCode/delete?reasonCode=${req.reasonCode}`);
}

function getAdjustmentZoneOptions(req) {
  return eHubApi.get(`/api/adjustment/zones?whCode=${req.warehouseCode}`);
}

function createAdjustment(req) {
  return eHubApi.post("/api/adjustment/create", req);
}

function getAdjustmentList(req) {
  return eHubApi.get(`/api/adjustment/list?customerCode=${req.customerCode}`);
}

function getAdjustment(req) {
  return eHubApi.get(
    `/api/adjustment/get?adjustmentNo=${req.adjustmentNo}&customerCode=${req.customerCode}`
  );
}

function createStockHold(req) {
  return eHubApi.post("/api/stockHold/create", req);
}

function getStockHoldList(req) {
  return eHubApi.get(`/api/stockHold/list?customerCode=${req.customerCode}`);
}

function getStockHold(req) {
  return eHubApi.get(
    `/api/stockHold/get?stockHoldNo=${req.stockHoldNo}&customerCode=${req.customerCode}`
  );
}

// function getPermissionsByTeams(req){
//     const teams = req.teams.join('&team=')
//     return eHubApi.get(`/api/teamRole/userRole?team=`+teams+`&type=Web`);
// }

function createCOReturnCode(req) {
  return eHubApi.post("/api/COReturnCode/create", req);
}

function getCOReturnCodeList(req) {
  return eHubApi.get(`/api/COReturnCode/list?active=${req.active}`);
}

function getCOReturnCode(req) {
  return eHubApi.get(`/api/COReturnCode/get?returnCode=${req.returnCode}`);
}

function editCOReturnCode(req) {
  return eHubApi.put(`/api/COReturnCode/edit?returnCode=${req.returnCode}`, req);
}

function deactivateCOReturnCode(req) {
  return eHubApi.del(`/api/COReturnCode/delete?returnCode=${req.returnCode}`);
}
function activateCOReturnCode(req) {
  return eHubApi.put(`/api/COReturnCode/activate?returnCode=${req.returnCode}`);
}
function getCOReturnCodeStatusCount() {
  return eHubApi.get("/api/COReturnCode/get-status-count");
}

function createPackagingMaterial(req) {
  return eHubApi.post("/api/PackagingMaterial/create", req);
}

function getPackagingMaterialList(req) {
  return eHubApi.get(`/api/PackagingMaterial/list?active=${req.active}`);
}

function getPackagingMaterial(req) {
  return eHubApi.get(`/api/PackagingMaterial/get?materialName=${req.materialName}`);
}

function editPackagingMaterial(req) {
  return eHubApi.put(`/api/PackagingMaterial/edit?materialName=${req.materialName}`, req);
}

function deactivatePackagingMaterial(req) {
  return eHubApi.del(`/api/PackagingMaterial/delete?materialName=${req.materialName}`);
}
function activatePackagingMaterial(req) {
  return eHubApi.put(`/api/PackagingMaterial/activate?materialName=${req.materialName}`);
}
function getPackagingMaterialStatusCount() {
  return eHubApi.get("/api/PackagingMaterial/get-status-count");
}

//LocationGroup
export const getLocationGroupList = (req) => eHubApi.get(`/api/LocationGroup/list?active=${req.active}`);

export const getLocationGroupStatusCount = () => eHubApi.get("/api/LocationGroup/get-status-count");

export const getLocationGroup = (req) =>
  eHubApi.get(`/api/LocationGroup/get?locDimGrp=${req.locDimGrp}`);

export const getLocationGroupOptions = () =>
  eHubApi.get(`/api/LocationGroup/options`);

export const createLocationGroup = (req) => eHubApi.post("/api/LocationGroup/create", req);

export const editLocationGroup = (req) =>
  eHubApi.put(`/api/LocationGroup/edit?locDimGrp=${req.locDimGrp}`, req.req);

export const deactivateLocationGroup = (req) =>
  eHubApi.del(`/api/LocationGroup/delete?locDimGrp=${req.locDimGrp}`);

export const activeLocationGroup = (req) =>
  eHubApi.put(`/api/LocationGroup/activate?locDimGrp=${req.locDimGrp}`);

//#region Country
export const createCountry = (req) => eHubApi.post("/api/country/create", req);

export const getCountryByCode = (code) => eHubApi.get(`/api/country/get?countryCode=${code}`);

export const editCountry = (req) =>
  eHubApi.put(`/api/country/edit?countryCode=${req.countryCode}`, req);

export const getCountryList = (req) => eHubApi.get(`/api/country/list?active=${req.active}`);

export const deactiveCountry = (req) =>
  eHubApi.del(`/api/country/delete?countryCode=${req.countryCode}`);

export const activeCountry = (req) =>
  eHubApi.put(`/api/country/activate?countryCode=${req.countryCode}`);

export const getCountryStatusCount = () => eHubApi.get("/api/country/get-status-count");
//#endregion Country

//#region API_URL_SETTING
export function getApiSettingList(customerCode) {
  return eHubApi.get(`/api/api-url-setting/get?customerCode=${customerCode}`);
}

export function updateApiSetting(payload) {
  return eHubApi.post(`/api/api-url-setting/edit`, payload);
}
//#endregion API_URL_SETTING

//#region Division
export function getDivisionList(req) {
  return eHubApi.get(`/api/division/list?active=${req.active}`);
}

export function getDivisionStatusCount(req) {
  return eHubApi.get(`/api/division/get-status-count`);
}

export function activateDivision(req) {
  return eHubApi.put(`/api/division/activate?divisionGroup=${req.divisionGroup}`);
}

export function deactivateDivision(req) {
  return eHubApi.del(`/api/division/deactivate?divisionGroup=${req.divisionGroup}`);
}

export function addEditDivision(req) {
  return eHubApi.post("/api/division/addedit", req);
}

export function getDivisionGroupOptions(req) {
  return eHubApi.get(`/api/division/options?customerCode=${req.customerCode}`);
}
//#endregion Division
export const editTracking = (req) => eHubApi.post("/api/internal/tracking/edit",req)

export const editIntegratedTracking = (req) => eHubApi.post("/api/internal/tracking/edit-integrated", req)

export const getDelyvaCreateOrderLog = (req) =>
  eHubApi.get(`/api/internal/delyva-create-order-log?custOrdNbr=${req.custOrdNbr}`)


//export const validateRecvDivisionUploadData = (req) => eHubApi.post("/api/inventory/division/validate",req);
export const validateRecvDivisionUploadData = (req) => {
  console.log("📦 validateRecvDivisionUploadData req:", req);
  return eHubApi.post("/api/adjustment/division/validate", req);
};

export {
  getRackList,
  getLocationsByRack,
  getSKUListByVendCode,
  getCategoryOptions,
  getGroupOptions,
  getSubGroupOptions,
  createPreferredLocation,
  getPreferredLocation,
  deactivatePreferredLocation,
  editPreferredLocationBySKU,
  deleteLocationForPrefLoc,
  getPreferredLocationList,
  getPreferredLocationStatusCount,
  uploadPreferredLocation,
  activatePreferredLocation,
  createPickFaceLocation,
  getPickFaceLocation,
  deactivatePickFaceLocation,
  activatePickFaceLocation,
  editPickFaceLocation,
  deleteLocationForPickFace,
  getPickFaceLocationList,
  getPickFaceLocationStatusCount,
  uploadPickFaceLocation,
  getVendorWithCustCode,
  getLocationsSetAsPickFace,
  getLocationsSetAsPreferred,
  deletePickFaceDetail,
  getModuleList,
  getModuleTypes,
  createTeamRole,
  editTeamRole,
  getTeamRole,
  getTeamRoleList,
  deactivateTeamRole,
  activateTeamRole,
  getTeamRoleStatusCount,
  createAdjustmentReason,
  getAdjustmentReasonList,
  getAdjustmentReason,
  editAdjustmentReason,
  deactivateAdjustmentReason,
  getAdjustmentZoneOptions,
  createAdjustment,
  getAdjustmentList,
  getAdjustment,
  createStockHold,
  getStockHoldList,
  getStockHold,
  createCOReturnCode,
  getCOReturnCode,
  getCOReturnCodeList,
  editCOReturnCode,
  deactivateCOReturnCode,
  activateCOReturnCode,
  getCOReturnCodeStatusCount,
  getCustomersByWarehouse,
  createPackagingMaterial,
  getPackagingMaterial,
  getPackagingMaterialList,
  editPackagingMaterial,
  deactivatePackagingMaterial,
  activatePackagingMaterial,
  getPackagingMaterialStatusCount,
};
